<!-- 段階的修正: まず基本機能を安定化 -->
<router-outlet></router-outlet>
